import { useRef } from "react";

import classnames from "classnames";

import { useAnalyticsTracker } from "components/instrumentation/source/analytics";
import { Button, Section, Text } from "components/ui/source";

import { csrfParam, csrfToken } from "../../shared/api/base_api";

import styles from "./Accounts.module.scss";

interface FourFactorAuthenticationFormPops {
  source?: string;
  forceLogout?: boolean;
  redirectPath?: string;
}

export function FourFactorAuthenticationForm({
  source,
  forceLogout,
  redirectPath,
}: FourFactorAuthenticationFormPops) {
  const formRef = useRef(null);
  const { analytics } = useAnalyticsTracker();

  async function onSubmit() {
    if (!formRef.current) return;

    const medium = "look-up";

    try {
      await analytics.track("Login Options Select", {
        method: medium,
        source: source,
      });
    } catch {
      // do nothing
    }

    const redirectUrl = redirectPath ?? "/profile";

    formRef.current.method = "post";
    formRef.current.action = `/accounts/auth/cognito_marriott?identity_provider=four-factor-authentication&redirect_path=${encodeURIComponent(
      redirectUrl,
    )}${forceLogout ? "&signout=true" : ""}`;

    formRef.current.submit();
  }

  return (
    <Section
      className={classnames(styles.lookUpFooterContainer, styles.centered_text)}
    >
      <form method="post" ref={formRef} data-testid="login-lookup-form">
        <input name={csrfParam()} value={csrfToken()} type="hidden" />
      </form>
      <Text
        id="lookUpFormSubheading"
        element="h4"
        className={classnames(styles.centered_text)}
        types={["headline4"]}
        translateKey={"modals.accounts.loginOptions.subtitle"}
      />
      <Button
        className={styles.lookUpFooterButton}
        type="dark_inverted"
        width="fit-content"
        upperCase={false}
        onClick={onSubmit}
      >
        <Text
          element="span"
          types={["body1"]}
          translateKey={"modals.accounts.loginOptions.buttons.lookup"}
        />
      </Button>
    </Section>
  );
}
